import { c as _c } from "react/compiler-runtime";
export const IconArrowDropDown = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.5814 9.5C7.40698 9.5 7.26647 9.55319 7.15988 9.65957C7.05329 9.76596 7 9.89007 7 10.0319C7 10.0674 7.05814 10.1915 7.17442 10.4043L11.3895 14.2606C11.4864 14.3493 11.5833 14.4113 11.6802 14.4468C11.7771 14.4823 11.8837 14.5 12 14.5C12.1163 14.5 12.2229 14.4823 12.3198 14.4468C12.4167 14.4113 12.5136 14.3493 12.6105 14.2606L16.8256 10.4043C16.8837 10.3511 16.9273 10.2934 16.9564 10.2314C16.9855 10.1693 17 10.1028 17 10.0319C17 9.89007 16.9467 9.76596 16.8401 9.65957C16.7335 9.55319 16.593 9.5 16.4186 9.5H7.5814Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
IconArrowDropDown.displayName = 'IconArrowDropDown';